// \this icon file upload changes
import React from 'react';
import { InformationCircle } from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/form/info-error.css';

const InfoIconWorkinfo = React.memo(() => (
  <div className="section-info-wrapper summary-info-wrapper" style={{ marginBottom: '10px' }}>
    <div className="section-info">
      <div className="info-svg-wrapper">
        <div className="info-svg">
          <InformationCircle />
        </div>
      </div>
      <div className="info-message">
        <p>Attachments above 3.5MB cannot be uploaded through the ACE Portal at the current time, and will need to be added directly in Remedy</p>
      </div>
    </div>
  </div>
));

export {
  InfoIconWorkinfo,
};
